import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuUnsentDeliveriesView } from "src/tenantCustomizations/tenants/mellano/views/luukku/deliveries/MellanoLuukkuUnsentDeliveriesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/unsentDeliveriesByAddress")({
	staticData: { title: "Lähettämättömät osoitteittain", legacyViewKey: "mellanoLuukkuUnsentDeliveriesByAddressView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuUnsentDeliveriesView scope={"ALL"} />;
}
